<template>
  <v-app>
    <Loader :is-visible="loading"></Loader>

    <template v-if="!this.$route.path.includes('inscricao')">
      <headerFormulario></headerFormulario>
    </template>

    <v-main>
      <selo-logo
        :drawer="drawer"
        @sendDrawer="(e) => (drawer = e)"
        v-if="
          this.$route.path.includes('inscricao/auth') &&
          !this.$route.path.includes('inscricao/auth/login')
        "
      ></selo-logo>
      <div
        class="d-flex mt-1"
        v-if="
          this.$route.path.includes('inscricao/auth') &&
          !this.$route.path.includes('inscricao/auth/login')
        "
      >
        <v-navigation-drawer v-model="drawer" temporary fixed>
          <v-list>
            <v-list-item link @click.stop="drawer = !drawer">
              <v-list-item-content>
                <v-list-item-title class="text-h6">
                  {{ getFirstName() }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-btn title="reduzir" icon>
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list nav dense>
            <v-list-item
              link
              title="Dashboard"
              @click="$router.push('/inscricao/auth/dashboard')"
            >
              <v-list-item-icon>
                <v-icon>mdi-chart-bar</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Dashboard</v-list-item-title>
            </v-list-item>
            <v-list-item
              link
              title="Listagem de Inscrições"
              @click="$router.push('/inscricao/auth/listar')"
            >
              <v-list-item-icon>
                <v-icon>mdi-format-list-checks</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Inscrições</v-list-item-title>
            </v-list-item>
            <v-list-item
              link
              v-if="isFullAdmin"
              title="Usuários"
              @click="$router.push('/inscricao/auth/usuarios')"
            >
              <v-list-item-icon>
                <v-icon>mdi-account-multiple</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Usuários</v-list-item-title>
            </v-list-item>
          </v-list>
          <div class="buttonSair" @click="logout">sair</div>
        </v-navigation-drawer>
        <div class="width">
          <router-view />
        </div>
      </div>
      <v-container
        :class="
          this.$route.path.includes('inscricao/auth/dashboard') ? '' : 'width'
        "
        v-else
      >
        <router-view />
      </v-container>
    </v-main>

    <template v-if="this.$route.path.includes('inscricao/auth')">
      <div class="footer">
        Selo Sebrae de Referência em Atendimento - Inscrições 2026
      </div>
    </template>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loader from "@/components/Loader";
import Auth from "@/Auth.js";
import Cookies from "@/components/cookies/cookies";
import { atualUfDefinition } from "./helpers/utils";
import HeaderFormulario from "@/components/headerFormulario/headerFormulario";
import SeloLogo from "@/components/seloLogo.vue";

export default {
  name: "App",
  components: {
    Loader,
    Cookies,
    HeaderFormulario,
    SeloLogo,
  },
  computed: {
    ...mapGetters(["loading", "isFullAdmin"]),
  },
  data() {
    return {
      drawer: false,
      estado: this.$store.state.uf,
      logouf: this.$store.state.logo,
      href: window.location.href,
      user: JSON.parse(localStorage.getItem("user")) || {},
      mini: true,
    };
  },

  created() {
    var token = localStorage.getItem("token") || null;
    var expired = localStorage.getItem("expired") || false;
    var user = JSON.parse(localStorage.getItem("user")) || {};

    if (token !== null) this.setToken(token);

    if (token !== null) {
      if (user.email === "admin@admin.com.br") {
        this.setFullAdmin(true);
      } else this.setFullAdmin(false);
      this.setUser(user);
    }

    Auth.setItem("expired", expired);
  },
  methods: {
    ...mapActions(["setToken", "setUser", "setFullAdmin", "setForcedLogout"]),
    mudaUf() {
      // this.setUrlTag(atualUfDefinition.urlTag);
      // this.setNA(atualUfDefinition.na);
      // this.setLogo(atualUfDefinition.logo);
      // this.setIsSala(atualUfDefinition.isSala);
      // this.setIsAT(atualUfDefinition.isAT);
      // this.setIndicadores(atualUfDefinition.isIndicadores);
      setInterval(function () {
        document.documentElement.style.setProperty(
          "--corPrimaria",
          atualUfDefinition.corPrimaria
        );
      }, 100);
    },
    getFirstName() {
      var user = JSON.parse(localStorage.getItem("user"));
      if (user) return user.nome.split(" ")[0];

      return "";
    },
    logout() {
      this.setForcedLogout(true);
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/inscricao/auth/login");
      });
    },
    enableInterceptor() {
      this.$http.interceptors.request.use(
        (config) => {
          return config;
        },
        (error) => {
          return Promise.reject(error);
        }
      );
      this.$http.interceptors.response.use(
        (response) => {
          return response;
        },
        (err) => {
          console.log("err: ", err);

          const status = (err.response && err.response.status) || 0;

          if (status === 401) {
            Auth.setItem("expired", true);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/auth/login");
            });
          }

          return Promise.reject(err);
        }
      );
    },
  },
  mounted() {
    this.enableInterceptor();
    this.mudaUf();
  },
};
</script>

<style lang="scss">
@import "./style.scss";

.footer {
  height: 50px;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#ffec69),
    to(#ffb381)
  );
  background-image: linear-gradient(to right, #2a4fda, #65b4f8);
  margin-top: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: bold;
}

.buttonSair {
  background-color: #5c8bb9;
  color: white;
  padding: 3px 10px;
  border-radius: 5px;
  margin: 0px 5px;
  text-align: center;
  cursor: pointer;
}

.buttonSair:hover {
  background-color: #284395;
}

.width {
  height: 100%;
  width: 100%;
  padding: 0 50px;
}
</style>
